export const UpdateNoteType = {
  PLATFORM: 'PLATFORM',
  EMISSION_FACTORS: 'EMISSION_FACTORS',
} as const;

export type UpdateNoteType =
  (typeof UpdateNoteType)[keyof typeof UpdateNoteType];

export const UPDATE_NOTE_TYPES: UpdateNoteType[] = [
  UpdateNoteType.PLATFORM,
  UpdateNoteType.EMISSION_FACTORS,
];

/**
 * A release note. The API returns every language column and the client resolves the active one —
 * see resolveUpdateNoteContent. Content is plain text: render it with `whitespace-pre-line`.
 */
export interface UpdateNote {
  id: string;
  type: UpdateNoteType;
  releasedAt: string;
  contentFR: string;
  contentEN: string;
  contentNL: string;
  createdAt: string;
  updatedAt: string;
}

/** Payload of the super-admin create/update endpoints. `releasedAt` must be `YYYY-MM-DD`. */
export interface UpdateNoteDto {
  type: UpdateNoteType;
  releasedAt: string;
  contentFR: string;
  contentEN: string;
  contentNL: string;
}

export interface UnseenUpdateNotesResponse {
  notes: UpdateNote[];
  count: number;
}
